<script lang="ts" setup>
import { ref, computed } from "vue";
import { HomeService } from "~/services/HomeService";
import LinkImage from "@/components/buttons/LinkImage.vue";
import BaseLink from "@/components/buttons/BaseLink.vue";
import { Jsona } from "jsona";

const routeHydrated = useRouteHydrated();
const seeMoreBrands = useState("home.moreNewBrands", () => "/");
const loading = ref(false);

interface IFakeBrand {
  name: string;
  image: string;
  image_sm: string;
  links: {
    self: string;
  };
}

const brands = useState<IFakeBrand[]>("home.brands", () => []);

const finalBrands = computed(() => brands.value.slice(0, 11));

const jsona = new Jsona();

const search = async () => {
  const homeService = new HomeService();
  if (!routeHydrated.value) {
    loading.value = true;
    try {
      const response = await homeService.getBrands(true);
      if (response) {
        brands.value = jsona.deserialize(
          JSON.stringify(response),
        ) as IFakeBrand[];
        seeMoreBrands.value = response.links.self;
      }
    } catch (err) {
      console.error(err);
    } finally {
      loading.value = false;
    }
  }
};

if (import.meta.server) {
  await search();
} else {
  search(); // en cliente mostramos pantallas de carga
}
</script>

<template>
  <section class="mt-4 mt-lg-5 px-3 px-lg-0 pt-lg-3">
    <div v-if="finalBrands.length > 0" class="find-by-brand">
      <h2 class="text-secondary title">Explora por marcas</h2>
      <div class="row row-cols-4 row-cols-xl-6 row-gap-3 mt-3">
        <div v-if="loading" class="col">
          <div class="px-1 px-md-2">
            <div
              class="gap-3 height-grid-col border border-light bg-light-subtle d-flex align-items-center justify-content-center shadow-sm"
            >
              <div class="spinner-grow text-light mx-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(brand, index) in finalBrands"
          :key="index"
          class="col"
          :class="{ 'brand-desktop-only': index >= 3 }"
        >
          <div class="px-1 px-md-2">
            <div class="gap-3 height-grid-col">
              <link-image
                :height-image="35"
                class="px-1 px-lg-2 py-1 py-lg-3 item h-100 w-100"
                :src="brand.image_sm || brand.image || ''"
                :alt="brand.name"
                :to="brand.links && brand.links.self ? brand.links.self : '/'"
              />
            </div>
          </div>
        </div>
        <div class="col d-flex align-items-center justify-content-center">
          <div class="px-1 px-md-2">
            <base-link
              :to="'/marcas'"
              class="item rounded-0 item h-100 w-100 d-flex align-items-center justify-content-center see_all"
            >
              Ver todas
              <i class="bi bi-plus-circle ms-1 fs-7" />
            </base-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="sass" scoped>
.height-grid-col
    height: 35px
    @media (min-width: 992px)
        height: 60px

.brand-desktop-only
    display: none

    @media (min-width: 992px)
        display: block
</style>
